﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customImageList from './tpl/customImageList.html';
import View_CustomImageListItem from './customImageListItem';

export default Marionette.CollectionView.extend({
    tagName: 'customImageList',
    childViewContainer: '#customImageList',
    childView: View_CustomImageListItem,
    getTemplate: function () {
        return tpl_customImageList();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    }
});
